import { cEl } from '../../util';

export default function Icon({ iconName }) {
    if (iconName) {
        const icon = cEl('span');
        icon.classList.add('material-icons-round');
        icon.innerHTML = iconName;
        return icon;
    }
    return null;
}
